
/**
*   工具函数集中管理
**/
var __Xtool_Utils = (function() {
       // 飞书通知优化版本
       function feishuNotification(config) {
        // 配置
        var baseConfig = {
            errorTitle: "异常提示", //错误title，便于区分错误类别
            isTest: false, //是否是测试，测试的话，不会执行飞书通知
            errorMsg: "", //错误详细信息
            errorLevel: 1, //报警级别，默认1级
            responsiblePerson: "", //错误负责人
            feishuBot: "https://open.feishu.cn/open-apis/bot/v2/hook/4ef03b5d-6743-4a0f-a4c0-eaa5ae322600", //上报的飞书群webhook
            errorResolvePage: "https://makeblock.feishu.cn/wiki/AwRwwlgVLig9WAktt3Pcq9Wlnod?table=tblCsC7OcLAAsJSJ&view=vew2op0261", //上报的飞书群错误处理文档
            feishutTemplateId: "ctp_AA1WWaWGD6hU", //上报的飞书群消息卡片,可在搭建工具中通过“复制卡片ID”获取
        };
        var finalConfig = {};
        function mergeConfig(baseConfig, config) {
            if (!config || !config.errorMsg) {
                return;
            }
            for (var key in config) {
                if (Object.prototype.hasOwnProperty.call(config, key)) {
                    if (key === "isTest") {
                        baseConfig[key] =
                            config[key] === undefined ? baseConfig[key] : config[key];
                    }
                    else {
                        baseConfig[key] = config[key] || baseConfig[key];
                    }
                }
            }
            return baseConfig;
        }
        try {
            finalConfig = mergeConfig(baseConfig, config) || {};
            if (finalConfig === null || finalConfig === void 0 ? void 0 : finalConfig.isTest) {
                return;
            }
        }
        catch (e) {
            console.info("mergeConfig报错", e);
            return;
        }
        var submitErrorUids = []; //错误去重过滤
        Promise.resolve(getIpLocation()).then(function (countryName) {
            var message = createFeishuMessage(finalConfig, countryName);
            sendFeishuMessage(message);
        });
        function getHeaders() {
            var headers = {};
            for (var key in navigator) {
                if (key.indexOf("appVersion") !== -1 ||
                    key.indexOf("userAgent") !== -1 ||
                    key.indexOf("platform") !== -1) {
                    headers[key] = navigator[key];
                }
            }
            return headers;
        }
        function getIpLocation() {
            try {
                // 读取数据时检查过期时间
                var storedData = JSON.parse(localStorage.getItem("feishuPostIps") || '');
                if (storedData && storedData.expiration > new Date().getTime()) {
                    return storedData.data.dtcStationCountryName;
                }
                else {
                    return fetch("https://dtc.mblock.cc/shopify/ip", { method: "GET" })
                        .then(function (response) { return response.json(); })
                        .then(function (res) {
                        // 存储数据和过期时间
                        var data = { dtcStationCountryName: res.data.country_name };
                        var expiration = new Date().getTime() + 3600000 * 24; // 设置过期时间为1天（以毫秒为单位）
                        localStorage.setItem("feishuPostIps", JSON.stringify({ data: data, expiration: expiration }));
                        return res.data.country_name;
                    });
                }
            }
            catch (error) {
                console.error("getIpLocation报错", error);
                return "";
            }
        }
        function createFeishuMessage(finalConfig, countryName) {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            return {
                msg_type: "interactive",
                card: {
                    type: "template",
                    data: {
                        template_id: finalConfig.feishutTemplateId,
                        template_variable: {
                            errorMsg: finalConfig.errorMsg,
                            responsiblePerson: finalConfig.responsiblePerson,
                            station: window.location.hostname,
                            pageUrl: window.location.href,
                            ip: countryName,
                            requestHeader: "".concat(JSON.stringify(getHeaders())),
                            userId: (_b = (_a = window === null || window === void 0 ? void 0 : window.makeblock) === null || _a === void 0 ? void 0 : _a.customer) === null || _b === void 0 ? void 0 : _b.id,
                            userEmail: (_d = (_c = window === null || window === void 0 ? void 0 : window.makeblock) === null || _c === void 0 ? void 0 : _c.customer) === null || _d === void 0 ? void 0 : _d.email,
                            errorLevel: finalConfig.errorLevel,
                            errorTitle: finalConfig.errorTitle,
                            errorResolvePage: finalConfig.errorResolvePage,
                            errorEnv: "".concat((_f = (_e = window === null || window === void 0 ? void 0 : window.Shopify) === null || _e === void 0 ? void 0 : _e.theme) === null || _f === void 0 ? void 0 : _f.name, ",role:").concat((_h = (_g = window === null || window === void 0 ? void 0 : window.Shopify) === null || _g === void 0 ? void 0 : _g.theme) === null || _h === void 0 ? void 0 : _h.role),
                        },
                    },
                },
            };
        }
        // 初始化上报方法
        function sendFeishuMessage(message) {
            try {
                return typeof navigator.sendBeacon === "function"
                    ? beaconTransport(message)
                    : fetchSendMessage(message);
            }
            catch (e) {
                console.info("sendFeishuMessage报错", e);
            }
        }
        // beacon 形式上报
        function beaconTransport(message) {
            var status = window.navigator.sendBeacon(finalConfig.feishuBot, JSON.stringify(message));
            // 如果数据量过大，则本次大数据量用 fetchSendFeishuMessage 上报
            if (!status)
                fetchSendMessage(message);
        }
        function fetchSendMessage(message) {
            fetch(finalConfig.feishuBot, {
                method: "POST",
                mode: "no-cors", //加这个字段才可以在浏览器里面直接发起ajax请求
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(message),
            });
        }
    }

    /**
     * @returns  Object
     */
        var getSignatureHeader = function() {
            var timeStamp = Math.floor(Date.now().toString()/1000);
            let secretKey = "7b141a46c423977f9d2dae3a0777cfa2";
            let sign_str = CryptoJS.MD5(timeStamp + ":" + secretKey).toString();
            return {
                'sign_str': sign_str,
                'time_stamp': timeStamp
            }
        }


    /**
     * @returns xcc生产地址
     */
    var getXccApiDomain = function() {
        if (window.Shopify.shop.indexOf('testxtool') > -1) {
            return '//dtc-dev.makeblock.com'
        }
        return '//dtc.mblock.cc'
    }

    /**
     * 
     * @param { Number } endTimeTimestamp 
     * @param { Number } startTimeTimestamp 
     * @returns 
     */

    const countDown = function(params) {

        const {
            startTimeTimestamp,
            endTimeTimestamp,
            index
        } = params || {};

        if (params) {
            window.sessionStorage.setItem('startTimeTimestamp', startTimeTimestamp)
            window.sessionStorage.setItem('endTimeTimestamp', endTimeTimestamp)
            window.sessionStorage.setItem('countdownIndex', index)
        }
        
        let timer = null;
        let isExpired = false;
        const nowTime = new Date();
        const beginDiff = parseInt((!startTimeTimestamp ? window.sessionStorage.getItem('startTimeTimestamp') : startTimeTimestamp) * 1000 - nowTime.getTime());
        const endDiff = parseInt((!endTimeTimestamp ? window.sessionStorage.getItem('endTimeTimestamp') : endTimeTimestamp) * 1000 - nowTime.getTime());
        const leftTime = beginDiff > 0 ? beginDiff : endDiff;

        const day = parseInt(leftTime / (24 * 60 * 60 * 1000));
        const hour = parseInt(leftTime / (60 * 60 * 1000) % 24);
        const minute = parseInt(leftTime / (60 * 1000) % 60);
        const second = parseInt(leftTime / 1000 % 60);

        if (beginDiff > 0) {
            timer = setTimeout(countDown, 1000);
            isExpired = false;
        } else if (leftTime <= 0) {
            clearTimeout(timer);
            window.sessionStorage.removeItem('startTimeTimestamp');
            window.sessionStorage.removeItem('endTimeTimestamp');
            window.sessionStorage.removeItem('countdownIndex');
            isExpired = true;
        } else {
            $(`.count-down__wrapper-${!index ? window.sessionStorage.getItem('countdownIndex') : index} .hour-msg`).text(hour);
            $(`.count-down__wrapper-${!index ? window.sessionStorage.getItem('countdownIndex') : index} .mins-msg`).text(minute);
            $(`.count-down__wrapper-${!index ? window.sessionStorage.getItem('countdownIndex') : index} .secs-msg`).text(second);
            timer = setTimeout(countDown, 1000);
            isExpired = false;
        }  
        
        return isExpired;
    }

    /**
     * 辅助函数，返回访问页面的设备类型（PC、Mobile、Pad）
     * @returns 'Pad' | 'Mobile' | 'PC'
     */
    const platform = function() {
        let ua = navigator.userAgent,
        isWindowsPhone = /(?:Windows Phone)/.test(ua),
        isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
        isAndroid = /(?:Android)/.test(ua),
        isFireFox = /(?:Firefox)/.test(ua),
        isChrome = /(?:Chrome|CriOS)/.test(ua),
        isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua)),
        isPhone = /(?:iPhone)/.test(ua) && !isTablet,
        isPc = !isPhone && !isAndroid && !isSymbian;

        return isTablet ? 'Pad' : (isPhone || isAndroid) ? 'Mobile' : isPc ? 'PC' : 'PC';
    }

    /**
     * 解析地址栏参数，保存在params对象中
     * @returns url参数对象
     */
    const getQueryParams = function() {
        var query = location.search.substring(1)
        var arr = query.split('&')
        var params = {}
        for (var i = 0; i < arr.length; i++) {
            var pair = arr[i].split('=')
            params[pair[0]] = pair[1]
        }
        return params  
    }

    /**
     * 兼容PC、移动端的点击事件
     */
    const tap = function(ele, callback) {
        if(this.platform() !== 'PC' ) {
            $(ele).on('touchstart', function(event) {
                callback(event);
            })
        }else {
            $(ele).on('click', function(event) {
                callback(event)
            })
        }
    }

    /** 动态创建script标签 */
    const loadScript = function (url, attr={}, cb) {
        let script = document.createElement('script');
        script.src = url;
        Object.keys(attr).forEach(key => {
            script[key] = attr[key] 
        })
        let firstScript = document.getElementsByTagName('script')[0];
        firstScript.parentNode.append(script,firstScript);

        // script 加载完毕后调用方法
        script.onload = script.onreadystatechange = function(){
            if( ! this.readyState     //这是FF的判断语句，因为ff下没有readyState这个值，IE的readyState肯定有值
                || this.readyState=='loaded' || this.readyState=='complete'   // 这是IE的判断语句
            ){
                cb && cb()
            }
        };
    }


    var listeners = [];
    var doc = document;
    var observer;
    function observerEleReady(selector, fn) {
        // 储存选择器和回调函数
        listeners.push({
            selector: selector,
            fn: fn
        });
        if (!observer) {
            // 监听document变化
            observer = new MutationObserver(check);
            observer.observe(doc.documentElement, {
                childList: true,
                subtree: true
            });
        }
        // 检查该节点是否已经在DOM中
        check();
    }

    function check() {
        // 检查是否匹配已储存的节点
        for (var i = 0; i < listeners.length; i++) {
            var listener = listeners[i];
            // 检查指定节点是否有匹配
            var elements = document.querySelectorAll(listener.selector);
            for (var j = 0; j < elements.length; j++) {
                var element = elements[j];
                // 确保回调函数只会对该元素调用一次
                if (!element.ready) {
                    element.ready = true;
                    // 对该节点调用回调函数
                    listener.fn.call(element, element);
                }
            }
        }
    }

    function firstWordToUpperCase(word) {
        return word.slice(0,1).toLocaleUpperCase() + word.slice(1)
    }

    function exceptionNotification(errTitle = '异常提示"', errorMsg = '') {
        getIpLocation().then((countryName) => {
            const message = createFeishuMessage(errTitle, countryName, errorMsg);
           sendFeishuMessage(message);
        });

        function getHeaders() {
            var headers = {};
            for (var key in navigator) {
                if (
                    key.indexOf("appVersion") !== -1 ||
                    key.indexOf("userAgent") !== -1 ||
                    key.indexOf("platform") !== -1
                ) {
                    headers[key] = navigator[key];
                }
            }
            return headers;
        }

        function getIpLocation() {
            return fetch("https://dtc.mblock.cc/shopify/ip", { method: "GET" })
                .then((response) => response.json())
                .then((res) => {
                    return res.data.country_name;
                });
        }

        function createFeishuMessage(title, countryName, error = '') {
            return JSON.stringify({
                msg_type: "post",
                content: {
                    post: {
                        zh_cn: {
                            title: title,
                            content: [
                                [
                                    {
                                        tag: "text",
                                        text: `ip: - ${countryName}\n`,
                                    },
                                    {
                                        tag: "text",
                                        text: `请求头: ${JSON.stringify(
                                            getHeaders()
                                        )}\n`,
                                    },
                                    {
                                        tag: "text",
                                        text: `用户id: ${window.theme.customer_id}\n`,
                                    },
                                    {
                                        tag: "text",
                                        text: `${error}\n`,
                                    },
                                    {
                                        tag: "text",
                                        text: `href: ${window.location.href}\n`,
                                    },

                                ],
                            ],
                        },
                    },
                },
            });
        }

        function sendFeishuMessage(message) {
            const feishuBot = `https://open.feishu.cn/open-apis/bot/v2/hook/4ef03b5d-6743-4a0f-a4c0-eaa5ae322600`;
            fetch(feishuBot, {
                method: "POST",
                body: `${message}`,
            });
        }
    }  
    
    // 设置cookie，seconds以秒为单位
    function setCookie(name, value, seconds) {
        var expires = "";
        if (seconds) {
            var date = new Date();
            date.setTime(date.getTime() + seconds * 1000);
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "")  + expires + "; path=/";
    }

    // 获取cookie
    function getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    }

    // 移除cookie
    function deleteCookie(name) {
        document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/;';
    }

    // 获取顶部的高度(header+topbar)
    function getHeaderFixedHeight() {
        const topbar = $('#topbar');
        const header = $('.header-nav');
        const topbarHeight = topbar.height() || 0;
        const headerHeight = header.height() || 0;

        const productPage = isProductPage();
        if (window.innerWidth > 1024 || window.scrollY === 0) {
            return productPage ? topbarHeight : topbarHeight + headerHeight;
        } else {
            return productPage ? 0 : headerHeight;
        }
    }

    function isProductPage() {
        return window.location.pathname.indexOf('/products/') === 0
    }

    var dateFormat = function (timestamp, format) {
        if (!timestamp) {
            return ''
        }
        let date = new Date(timestamp)
        const fullYear = date.getFullYear();
        const result = format.replace('YYYY', fullYear)
            .replace('YY', fullYear.toString().slice(-2))
            .replace('MM', (date.getMonth() + 1).toString().padStart(2, '0'))
            .replace('DD', date.getDate().toString().padStart(2, '0'))
            .replace('HH', date.getHours().toString().padStart(2, '0'))
            .replace('mm', date.getMinutes().toString().padStart(2, '0'))
            .replace('ss', date.getSeconds().toString().padStart(2, '0'))

        return result
    }
  
    return {
        getSignatureHeader,
        feishuNotification,
        getXccApiDomain,
        countDown,
        platform,
        getQueryParams,
        tap,
        loadScript,
        observerEleReady,
        firstWordToUpperCase,
        exceptionNotification,
        setCookie,
        getCookie,
        deleteCookie,
        getHeaderFixedHeight,
        dateFormat
    }
})();

/**
*   在init的同时传入相关参数
**/
;(function(win) {
    if(!win.jQuery){
        $ = {};
        $.fn = {};
    } else if(!win.$) {
        win.$ = jQuery;
    }

	/**
	 * 工具集
	 * */
	$.tools = {	
		format: function( str, data ){			
			var matchs = str.match(/{[^}]+?}/g);

			if( matchs === null ){
				return '';
			}
            
			var maLen = matchs.length;
			data = data instanceof Array ? data : [data];	
			
			var html = '';
			for( var n=0, len=data.length; n<len; n++ ){
				var obj = data[n];
	
				var temp = str;
				for( var i=0; i<maLen; i++ ){				
					var match = matchs[i];
					var name = match.replace(/{|}/g, "");
					temp = temp.replace( match, obj[name] || '' );
				}
	
				html += temp;
			}		
			
			return html;
		}
	}

    /*
    * 分页相关
    */
    $.Pager = function(){
    	this.el = null

        this.inited = 0  //是否已经初始化过

        this.curPage = 1
        this.totalPage = 0

        this.total = 0
        this.pageSize = 10
        
        this.showJump = false;

        this.splitStr = '<li class="disabled"><span class="splitStr"></span></li>'

        this.template = 
            '<div class="pager-list">'+
            '    <div class="pager-prev{prevAble}"><</div>'+
            '    <ul>{pageList}</ul>'+
            '    <div class="pager-next{nextAble}">></div>'+
            '</div>'
    }

    ///初始化
    $.Pager.init = function( opt ){  
    	var page = new $.Pager();
       
        for( var name in opt ){
            if( opt.hasOwnProperty(name) ){
                page[name] = opt[name];
            }
        }    
        
        var el = opt && opt.el || '[pager]';        
        el = typeof el === 'string' ? document.querySelector(el) : el;
        
        if( el.size && el.size() > 0 ){
        	el = el[0];
        }
        
        //元素是否存在
        if( !el ){
            console.error( '请指定页码元素, 然后再刷新' );
            return;
        } 
            
        //是否显示jump
        page.showJump = page.showJump ? 'inline-block' : 'none';
        page.el = el;        
        page.totalPage = Math.ceil( page.total / page.pageSize );        
        page.updatePage();
        
        if( !page.inited ){
            page.inited = 1;
            page.event();
        } 
    }

    ///更新页码
    $.Pager.prototype.updatePage = function(){       
        var pageList = '';
        var start = this.curPage - 2 > 1 ? this.curPage - 2 : 2;
        var end = this.curPage + 2 < this.totalPage ? this.curPage + 2 : this.totalPage-1;

		if( this.totalPage > 0 ){
	        //第一部分
	        pageList += '<li';
	        pageList += this.curPage === 1 ? ' class="cur"' : '';
            pageList += '>1</li>{splitBefore}';
	
	        //中间页码
	        for( var i=start; i<= end; i++ ){
	            pageList += '<li';
	            pageList += i === this.curPage ? ' class="cur"' : '';
	            pageList += '>' + i + '</li>';
	        }
            // console.log(end, "endend")
	        //最后部分
	        if( this.totalPage != 1 ){            
                pageList += '{splitAfter}<li';
	            pageList += this.curPage === this.totalPage ? ' class="cur"' : '';
	            pageList += '>' + this.totalPage + '</li>';
	        }
	    }

        var splitData = {
            splitBefore: this.curPage>2 ? this.splitStr: '',
            splitAfter: this.curPage<this.totalPage-3 ? this.splitStr: ''
        };
        
        pageList = $.tools.format( pageList, splitData ); 


        //页码信息
        var pageData = {
        	showJump: this.showJump,
        	
            //上一页与下一页按钮控制
            prevAble: this.curPage === 1 ? ' disabled' : '',
            nextAble: this.curPage === this.totalPage || this.totalPage==0 ? ' disabled' : '',

            curPage: this.curPage,
            totalPage: this.totalPage,
            pageSize: this.pageSize,
            total: this.total,

            pageList: pageList
        };
        
        var pageHtml = $.tools.format( this.template, pageData );    
        
        if( !this.totalPage ){
        	pageHtml = '';
        }
        
        this.el.innerHTML = pageHtml;
    }


    ///事件处理
    $.Pager.prototype.event = function(){
        var _this = this;
                
        _this.el.addEventListener("selectstart", function(e){ e.preventDefault();});        
        // if (__Xtool_Utils.isMobile()) {
        //     _this.el.addEventListener("touchstart", onClickLi, false);
        // } else {
        //     _this.el.addEventListener("click", onClickLi, false);
        // }
        
        _this.el.addEventListener("click", onClickLi, false);
        
        function onClickLi(e){
	        var target = e.target;
	        var tagName = target.tagName;
	        var page = target.textContent - 0;
	        var className = target.className;
	
	        if( target.classList.contains("disabled") || target.classList.contains("cur") ){
	            return false;
	        }
	
	        switch( className ){
	            case '': tagName==="LI" && _this.goPage( page ); break;
	            case 'pager-prev': _this.prev(); break;
	            case 'pager-next': _this.next(); break;   
	            case 'jump-btn': _this.jump(); break;
	        }
	    }
    }
    
    $.Pager.prototype.prev = function(){
        if( this.curPage > 1 ){
            this.curPage--
        }else{
        	return;
        }
        this.goPage();
    }

    $.Pager.prototype.next = function(){
        if( this.curPage < this.totalPage ){
            this.curPage++
        }else{
        	return;
        }
        this.goPage();
    }
    
    $.Pager.prototype.jump = function(){    	
    	var inputEl = this.el.getElementsByTagName('input')[0];
    	var pageIndex = inputEl.value.trim() - 0;
    	if( isNaN(pageIndex) ){
    		console.error('请输入数字');
    		pageIndex = this.curPage;
    	}
    	this.goPage( pageIndex );
    }

    $.Pager.prototype.goPage = function( pageIndex ){        
        this.curPage = pageIndex || this.curPage;
    	
    	this.curPage = this.curPage < 1 ? 1: this.curPage;    	
    	this.curPage = this.curPage > this.totalPage ? this.totalPage: this.curPage;
    	
        this.updatePage();
        this.onJump && this.onJump( this.curPage );
    }

    return $.Pager;
})(window);


// '<div class="pager-info">'+
//     '<span class="pager-index-tip">共{total}条,每页{pageSize}</span>'+
//     '<span class="pager-index-tip">{curPage}/{totalPage}</span>'+
//     '<div class="pager-jump" style="display:{showJump}">' +
//         '跳转到 <input value="{curPage}" maxlength="6" />' +
//         '<button class="jump-btn">确定</button>'+
//     '</div>' + 
// '</div>'+
